if (window.__mainpage_public_path__) {
  __webpack_public_path__ = window.__mainpage_public_path__;
}

if (window.__gibName__) {
  var script = document.createElement('script'),
  head = document.getElementsByTagName('head')[0];
  script.defer = true;
  script.type = 'text/javascript';
  script.src = 'https://www.cian.ru/' + window.__gibName__ + '.js';
  head.appendChild(script);
}

require('./index.tsx');
